import type { CabinState } from "../types/domain";

export const MAX_RANGE_KM = 750;
export const MAX_FUEL_RANGE_KM = 650;
export const ENERGY_OK_COLOR = "#54D95D";
export const ENERGY_WARNING_COLOR = "#FFC857";
export const ENERGY_DANGER_COLOR = "#FF5A5F";

export function rangeFromBatteryLevel(batteryLevel: number) {
  const numericBatteryLevel = Number(batteryLevel);
  const safeBatteryLevel = Number.isFinite(numericBatteryLevel)
    ? Math.max(0, Math.min(100, numericBatteryLevel))
    : 0;
  return Math.round((safeBatteryLevel / 100) * MAX_RANGE_KM);
}

export function rangeFromFuelLevel(fuelLevel: number) {
  const numericFuelLevel = Number(fuelLevel);
  const safeFuelLevel = Number.isFinite(numericFuelLevel)
    ? Math.max(0, Math.min(100, numericFuelLevel))
    : 0;
  return Math.round((safeFuelLevel / 100) * MAX_FUEL_RANGE_KM);
}

export function energyColorForBatteryLevel(batteryLevel: number) {
  const safeBatteryLevel = Number.isFinite(Number(batteryLevel)) ? Number(batteryLevel) : 0;

  if (safeBatteryLevel < 10) {
    return ENERGY_DANGER_COLOR;
  }

  if (safeBatteryLevel < 30) {
    return ENERGY_WARNING_COLOR;
  }

  return ENERGY_OK_COLOR;
}

export function fuelColorForFuelLevel(fuelLevel: number) {
  return energyColorForBatteryLevel(fuelLevel);
}

export function withDerivedRange(state: CabinState): CabinState {
  return {
    ...state,
    rangeKm: rangeFromBatteryLevel(state.batteryLevel),
    fuelRangeKm: rangeFromFuelLevel(state.fuelLevel)
  };
}
